import React from 'react'
import { useTranslation } from 'react-i18next'
import { Alert, Button, Snackbar } from '@mui/material'
import { useRegisterSW } from 'virtual:pwa-register/react'

const updateIntervalMS = 60 * 60 * 1000

const ReloadPrompt: React.FC = () => {
  const { t } = useTranslation('', { keyPrefix: 'offline' })
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      if (r) {
        setInterval(() => r.update(), updateIntervalMS)
      }
    },
    onRegisterError(error) {
      window.console.log('SW registration error', error)
    },
  })

  const handleUpdate = () => {
    updateServiceWorker(true)
  }

  const handleClose = () => {
    setNeedRefresh(false)
  }

  return (
    <Snackbar autoHideDuration={6000} onClose={handleClose} open={needRefresh}>
      <Alert
        action={
          <Button color={'inherit'} onClick={handleUpdate} size={'small'}>
            {t('reload')}
          </Button>
        }
        onClose={handleClose}
        severity={'info'}
      >
        {t('updateAvailable')}
      </Alert>
    </Snackbar>
  )
}

export default ReloadPrompt
